<template>
  <v-list-item class="px-0 py-3 d-flex flex-column">
    <v-list-item-title class="insights-filter-title">{{ $t('insights.filters.packages')}}</v-list-item-title>
    <VfAutoSelect
      :items="packages"
      v-model="selectedPackagesModel"
      nameField="name"
      valueField="id"
      hide-details
      allowSingleDelete
      :placeholder="$t('insights.filters.packagesPlaceholder')"
      class="pb-1 pt-3 insights-filter-input-text full-width"
    />
  </v-list-item>
</template>

<script>
export default {
  name: 'PackagesFilter',
  props: {
    packages: {
      type: Array,
      required: true,
      default: () => []
    },
    selectedPackages: {
      type: Array
    }
  },
  emits: ['selectedPackagesInput'],
  data () {
    return {

    }
  },
  computed: {
    selectedPackagesModel: {
      get () {
        return this.selectedPackages
      },
      set (value) {
        this.$emit('selectedPackagesInput', value)
      }
    }
  }
}
</script>

<style scoped>
</style>
